import { useEffect, useState } from 'react'

/** Aktuel tid, opdateret hvert sekund mens `active` er sand. Kun til visning. */
export function useNow(active = true): number {
  const [now, setNow] = useState(() => Date.now())

  useEffect(() => {
    if (!active) return
    setNow(Date.now())
    const id = window.setInterval(() => setNow(Date.now()), 1000)
    return () => window.clearInterval(id)
  }, [active])

  return now
}
